class ProductFormVariantMetafields {
    value = null;
    product = null;
    variant = null;
    selectors = {
        metafields: ".product-metafields",
        metafield: "#product-metafield",
        metafieldLabel: ".product-metafield__label",
        metafieldValue: ".product-metafield__value",
    }
    variantMetafieldsMap;

    /**
     * @param {HTMLSelectElement} select
     */
    constructor(select) {
        this.select = select;
        this.select.addEventListener('click', this.buildMetafields.bind(this));
        this.variantMetafieldsMap = window.variantMetafieldsMap || {};
        this.buildMetafields().then(() => {});
    }

    async buildMetafields() {
        const variant = await this.getCurrentVariant();
        const metafields = document.querySelector(this.selectors.metafields);
        if (!metafields) return;
        metafields.innerHTML = '';
        const metafieldTemplate = document.querySelector(this.selectors.metafield).cloneNode(true);

        const variantValues = this.variantMetafieldsMap[variant.id] || {};

        for (const [_key, variantValue] of Object.entries(variantValues)) {
            const metafield = document.importNode(metafieldTemplate.content, true);
            const wrapper = document.createElement('div');
            wrapper.classList.add('product-metafield');

            const labelElement = metafield.querySelector(this.selectors.metafieldLabel);
            const valueElement = metafield.querySelector(this.selectors.metafieldValue);

            const value = variantValue?.value;

            if (value) {
                if (typeof value === 'object') {
                    if (Array.isArray(value)) {
                        valueElement.textContent = value.map(obj => Object.values(obj)).join(', ');
                    } else {
                        valueElement.textContent = Object.values(value).join(', ');
                    }
                } else {
                    valueElement.textContent = value;
                }
            }

            labelElement.textContent = variantValue.label + ": ";

            wrapper.appendChild(labelElement);
            wrapper.appendChild(valueElement);

            metafields.appendChild(wrapper);
        }
    }

    async getCurrentProduct() {
        let url;

        url = `//${window.location.host + window.location.pathname}.json`;
        let response = await fetch(url);

        let {product} = await response.json();

        return product;
    }

    async getCurrentVariant() {
        const {variants} = await this.getCurrentProduct();
        return variants.find(variant => variant.id === +this.select.value);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const productVariantSelector = document.querySelector('.product-variants [name="id"]');
    if (productVariantSelector) {
        new ProductFormVariantMetafields(productVariantSelector);
    }
});
